module.exports = __webpack_public_path__ + "img/logo-3.669f4de5.png";